{
    "validation.maxAttachments": "only {{max}} attachments are allowed",
    "validation.minAttachments": "at least {{min}} attachments are required",
    "validation.maxAttachmentSize": "Attachments can't be bigger than {{max}} Megabytes",
    "validation.attachmentListItemRequired": "please provide an attachment for \"{{category}}\"",
    "validation.attachmentListItemMaxAttachments": "only {{max}} attachments for \"{{category}}\" are allowed",
    "validation.attachmentListItemMaxAttachmentSize": "{{category}} attachments can't be bigger than {{max}} Megabytes",
    "attachment.bsoCategory.DiagnosticReport": "Diagnostic Report",
    "attachment.bsoCategory.InvoiceDocument": "Invoice Document",
    "attachment.bsoCategory.ShippingDocument": "Shipping Document",
    "attachment.bsoCategory.Letter": "Letter",
    "attachment.bsoCategory.PictureReference": "Picture Reference",
    "attachment.bsoCategory.BugReport": "Bug Report",
    "attachment.bsoCategory.Other": "Other",
    "attachment.bsoCategory.Unclassified": "Unclassified",
    "attachment.bsoCategory.ServiceForms": "Service Form",
    "attachment.bsoCategory.RegistrationDocument": "Registration Document",
    "attachment.bsoCategory.ShopInside": "Image of Shop Interior",
    "attachment.bsoCategory.ShopImageMigration": "Shop image Migration",
    "attachment.bsoCategory.ShopImage": "Image of Shopfront",
    "attachment.uploadButton": "Upload {{category}}",
    "attachment.uploadDropdown": "Upload a File"
}